import { render, staticRenderFns } from "./ReturnMultipleAssignments.vue?vue&type=template&id=68b24063"
import script from "./ReturnMultipleAssignments.js?vue&type=script&lang=js&external"
export * from "./ReturnMultipleAssignments.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports